import { GameManager } from "../../GameManager";
import { UpperContainer } from "./UpperContainer";
import { LowerContainer } from "./LowerContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RouletteContainer } from "./roulette/RouletteContainer";
import { RouletteManager } from "./RouletteManager";
import { PrizeContainer } from "./PrizeContainer";

export class RouletteScene extends Phaser.Scene {

    public static currentInstance: RouletteScene;

    private static firstInstantiation = true;
    
    public roulette: RouletteContainer;
    public rouletteManager: RouletteManager;
    
    private upperContainer: UpperContainer;
    private lowerContainer: LowerContainer;
    private prizeContainer: PrizeContainer;
   
    constructor() {

        super("RouletteScene");
    }

    public create(): void {

        RouletteScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        this.rouletteManager = new RouletteManager();

        this.anims.create({ key: "border-glow", frames: this.anims.generateFrameNames( "texture_atlas_1", {prefix: "gold_shine_", start: 1, end: 35, zeroPad: 4, suffix: ""}), frameRate: 30, hideOnComplete: false});
       
        const background = this.add.graphics();
        background.fillStyle(0xFF0000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.roulette = new RouletteContainer(this);
        this.add.existing(this.roulette);

        this.upperContainer = new UpperContainer(this);
        this.add.existing(this.upperContainer);

        this.lowerContainer = new LowerContainer(this);
        this.add.existing(this.lowerContainer);

        if (RouletteScene.firstInstantiation) {

            RouletteScene.firstInstantiation = false;

            const background = this.add.graphics();
            background.fillStyle(0xFF0000);
            background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
    
            this.add.tween({
                targets: background,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 450,
                onComplete: function(): void {
                    background.destroy();
                },
                onCompleteScope: this
            });
        }
    }

    public update(): void {

        this.roulette.update();

        this.lowerContainer.update();
    }

    public spin(): void {

        this.roulette.spin();

        this.upperContainer.onSpin();
    }

    public showStopButton(): void {

        this.time.delayedCall(1500, function(): void {
            this.lowerContainer.showStopButton();
        }, [], this);  
    }
    
    public stop(slowDownAngularSpeed: number): void {

        this.roulette.stop(slowDownAngularSpeed);
    }
    
    public onRouletteStopped(): void {

        setTimeout(function(): void {
            RouletteScene.currentInstance.showPrize();
        }, 750);
    }

    public showPrize(): void {

        this.roulette.onPrizeShown();
        this.upperContainer.onPrizeShown();
        this.lowerContainer.onPrizeShown();

        this.prizeContainer = new PrizeContainer(this);
        this.add.existing(this.prizeContainer);
    }
}
